import { Component, Input, OnInit } from '@angular/core';
import { LeadGenerationCodeService } from '../../../lead-generation/shared/lead-generation-code.service';
import 'brace/theme/dawn';
import { AmplitudeService } from '../../../shared/services/amplitude.service';

@Component({
  selector: 'cc-web-call-installation-guide',
  templateUrl: './web-call-installation-guide.component.html',
  styleUrls: ['./web-call-installation-guide.component.scss']
})
export class WebCallInstallationGuideComponent implements OnInit {
  @Input() provider: 'JavaScript' | 'Shopify' | 'Wordpress';
  iconSrc: string;
  translateKey: string;
  codeToInstall: string;
  expanded = false;

  constructor(
    private leadGenerationCodeService: LeadGenerationCodeService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.iconSrc = `assets/img/channels/webcall-installation-${this.provider.toLowerCase()}.svg`;
    this.translateKey = this.provider.toUpperCase();
    this.codeToInstall = this.leadGenerationCodeService.htmlCodeToInstall();
  }

  expand() {
    this.expanded = true;
    this.logAmplitude('Expand');
  }

  collapse() {
    this.expanded = false;
    this.logAmplitude('Collapse');
  }

  private logAmplitude(message: string) {
    this.amplitudeService.logEvent(`Panel:FirstSteps:Installation: ${message}`, {
      provider: this.provider
    });
  }
}
